import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function MoonStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M8.16797 6.52441C8.16801 5.55055 8.31769 4.6108 8.5957 3.72754C5.45022 5.093 3.25002 8.22623 3.25 11.873C3.25 16.7756 7.22437 20.75 12.127 20.75C15.774 20.75 18.9061 18.5491 20.2715 15.4033C19.3884 15.6812 18.4492 15.832 17.4756 15.832C12.3354 15.832 8.16797 11.6647 8.16797 6.52441ZM9.66797 6.52441C9.66797 10.8363 13.1638 14.332 17.4756 14.332C18.804 14.332 20.053 14.0007 21.1465 13.417C21.4062 13.2783 21.7235 13.304 21.957 13.4834C22.1905 13.6629 22.2977 13.9632 22.2305 14.25C21.1557 18.8353 17.0409 22.25 12.127 22.25C6.39594 22.25 1.75 17.6041 1.75 11.873C1.75002 6.95903 5.16555 2.84419 9.75098 1.76953L9.8584 1.75293C10.1103 1.73156 10.3596 1.83863 10.5166 2.04297C10.696 2.27648 10.7217 2.59376 10.583 2.85352C9.99921 3.94696 9.66804 5.19591 9.66797 6.52441Z"
				fill="currentColor"
			/>
		</svg>
	);
}

MoonStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default MoonStrokeIcon;
